import { render, staticRenderFns } from "./letter-print.vue?vue&type=template&id=6078008b&scoped=true"
import script from "./letter-print.vue?vue&type=script&lang=ts"
export * from "./letter-print.vue?vue&type=script&lang=ts"
import style0 from "./letter-print.vue?vue&type=style&index=0&id=6078008b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078008b",
  null
  
)

export default component.exports